<template lang="html">
  <b-card style="padding:40px;">
    <h5><b>AMEND CHANGES (MONTHLY FORECAST)</b></h5>
    <hr />

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-size`">Product Type</label>
          <b-form-input
            v-model="form.type"
            id="input-horizontal"
            type="text"
            class="input-new"
            required
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="5">
        <b-form-group>
          <label for="input-default">
            Product Name<span class="danger-new"> *</span>
          </label>
          <multiselect
            v-model="input.product_name"
            :options="product_name"
            :custom-label="nameWithSKU"
            placeholder="Please select"
            label="name"
            track-by="name"
          ></multiselect>
          <p v-if="error.product_name">
            <span class="danger-new">{{ this.error.product_name }}</span>
          </p>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group>
          <label for="input-default">
            Quantity<span class="danger-new"> *</span>
          </label>

          <b-form-input
            v-model="input.qty"
            id="input-horizontal"
            class="input-new"
            required
          ></b-form-input>
          <p v-if="error.qty">
            <span class="danger-new">{{ this.error.qty }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <label for="input-week">Week<span class="danger-new"> *</span></label>
          <b-form-select
            v-model="input.weeks"
            :options="select.weeks"
            class="input-new"
            required
            :disabled="disableWeek"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="2">
        <b-form-group>
          <b-button variant="primary" size="m" @click="onClickAdd">+</b-button>
          &nbsp;&nbsp;&nbsp;
          <b-button variant="danger" size="m" @click="onClickReset">x</b-button>
        </b-form-group>
      </b-col>
    </b-row>

    <b-tabs v-model="tabIndex" content-class="mt-3">
      <b-tab title="Week 1" active>
        <br />
        <b-table
          head-variant="dark"
          striped
          hover
          bordered
          :items="items.data1"
          :fields="fields"
        >
          <template v-slot:cell(no)="data">
            {{ data.index + 1 }}
          </template>

          <template v-slot:cell(action)="data">
            <span>
              <b-button
                variant="primary"
                size="sm"
                @click="onClickEdit(data.index, data.item.week)"
              >
                EDIT
              </b-button>
              &nbsp;&nbsp;&nbsp;
              <b-button
                @click="onClickDel(data.index, data.item.week)"
                variant="primary"
                size="sm"
              >
                DELETE
              </b-button>
            </span>
          </template>
        </b-table>
      </b-tab>

      <b-tab title="Week 2">
        <br />
        <b-table
          head-variant="dark"
          striped
          hover
          bordered
          :items="items.data2"
          :fields="fields"
        >
          <template v-slot:cell(no)="data">
            {{ data.index + 1 }}
          </template>

          <template v-slot:cell(action)="data">
            <span>
              <b-button
                variant="primary"
                size="sm"
                @click="onClickEdit(data.index, data.item.week)"
              >
                EDIT
              </b-button>
              &nbsp;&nbsp;&nbsp;
              <b-button
                @click="onClickDel(data.index, data.item.week)"
                variant="primary"
                size="sm"
              >
                DELETE
              </b-button>
            </span>
          </template>
        </b-table>
      </b-tab>

      <b-tab title="Week 3">
        <br />
        <b-table
          head-variant="dark"
          striped
          hover
          bordered
          :items="items.data3"
          :fields="fields"
        >
          <template v-slot:cell(no)="data">
            {{ data.index + 1 }}
          </template>

          <template v-slot:cell(action)="data">
            <span>
              <b-button
                variant="primary"
                size="sm"
                @click="onClickEdit(data.index, data.item.week)"
              >
                EDIT
              </b-button>
              &nbsp;&nbsp;&nbsp;
              <b-button
                @click="onClickDel(data.index, data.item.week)"
                variant="primary"
                size="sm"
              >
                DELETE
              </b-button>
            </span>
          </template>
        </b-table>
      </b-tab>
      <b-tab title="Week 4">
        <br />
        <b-table
          head-variant="dark"
          striped
          hover
          bordered
          :items="items.data4"
          :fields="fields"
        >
          <template v-slot:cell(no)="data">
            {{ data.index + 1 }}
          </template>

          <template v-slot:cell(action)="data">
            <span>
              <b-button
                variant="primary"
                size="sm"
                @click="onClickEdit(data.index, data.item.week)"
              >
                EDIT
              </b-button>
              &nbsp;&nbsp;&nbsp;
              <b-button
                @click="onClickDel(data.index, data.item.week)"
                variant="primary"
                size="sm"
              >
                DELETE
              </b-button>
            </span>
          </template>
        </b-table>
      </b-tab>
      <b-tab title="Week 5">
        <br />
        <b-table
          head-variant="dark"
          striped
          hover
          bordered
          :items="items.data5"
          :fields="fields"
        >
          <template v-slot:cell(no)="data">
            {{ data.index + 1 }}
          </template>

          <template v-slot:cell(action)="data">
            <span>
              <b-button
                variant="primary"
                size="sm"
                @click="onClickEdit(data.index, data.item.week)"
              >
                EDIT
              </b-button>
              &nbsp;&nbsp;&nbsp;
              <b-button
                @click="onClickDel(data.index, data.item.week)"
                variant="primary"
                size="sm"
              >
                DELETE
              </b-button>
            </span>
          </template>
        </b-table>
      </b-tab>
    </b-tabs>

    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickSubmit"
          >SUBMIT</b-button
        >
      </b-col>
    </b-row>

    <b-modal id="delete-modal" title="Delete">
      <p class="my-4">Are you confirm to delete?</p>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          Close
        </b-button>
        <b-button variant="danger" size="sm" @click="onClickDelConfirm">
          Delete
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
// import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },

  data() {
    return {
      input: {
        pro_stock_id: null,
        product_name: "",
        qty: "",
        weeks: "1"
      },

      // Disable week
      disableWeek: false,

      form: {
        type: "",
        id: "",
        month: "",
        year: ""
      },

      // Current Index
      curIndex: "",
      // Current week
      curWeek: "",

      product_name: [],

      error: {
        product_name: "",
        qty: ""
      },

      tabIndex: 0,

      items: {
        data1: [],
        data2: [],
        data3: [],
        data4: [],
        data5: []
      },

      select: {
        // week
        weeks: [
          { text: "Week 1", value: "1" },
          { text: "Week 2", value: "2" },
          { text: "Week 3", value: "3" },
          { text: "Week 4", value: "4" },
          { text: "Week 5", value: "5" }
        ]
      },

      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Action",
          key: "action",
          sortable: false
        }
      ]
    };
  },

  created() {
    this.showMF();
    this.getProduct();
    this.form.type =
      parseInt(this.$route.query.pro_cat) === 1 ? "UHT" : "Pasteurized";
  },

  methods: {
    // Get Stockout
    showMF() {
      this.$store
        .dispatch("showMF", {
          fc_id: this.$route.query.id,
          category: 3
        })
        .then(res => {
          if (res.data.response.code === 100) {
            // get id
            this.form.id = res.data.data.fc_id;
            // get month
            this.form.month = res.data.data.month;
            // get year
            this.form.year = res.data.data.year;

            let week = res.data.data.fc_week;
            week.forEach(item => {
              // Week 1
              if (item.week === 1) {
                let week1 = [];
                item.pro_stock.forEach(item2 => {
                  week1.push({
                    isActive: true,
                    pro_stock_id: item2.pro_stock_id,
                    name: item2.product.name,
                    sku: item2.product_id,
                    quantity: item2.quantity,
                    index: item2.index,
                    week: "1",
                    action: "fas fa-user"
                  });
                });
                this.items.data1 = week1;
              }

              // Week 2
              if (item.week === 2) {
                let week2 = [];
                item.pro_stock.forEach(item2 => {
                  week2.push({
                    isActive: true,
                    pro_stock_id: item2.pro_stock_id,
                    name: item2.product.name,
                    sku: item2.product_id,
                    quantity: item2.quantity,
                    index: item2.index,
                    week: "2",
                    action: "fas fa-user"
                  });
                });
                this.items.data2 = week2;
              }

              // Week 3
              if (item.week === 3) {
                let week3 = [];
                item.pro_stock.forEach(item2 => {
                  week3.push({
                    isActive: true,
                    pro_stock_id: item2.pro_stock_id,
                    name: item2.product.name,
                    sku: item2.product_id,
                    quantity: item2.quantity,
                    index: item2.index,
                    week: "3",
                    action: "fas fa-user"
                  });
                });
                this.items.data3 = week3;
              }

              // Week 4
              if (item.week === 4) {
                let week4 = [];
                item.pro_stock.forEach(item2 => {
                  week4.push({
                    isActive: true,
                    pro_stock_id: item2.pro_stock_id,
                    name: item2.product.name,
                    sku: item2.product_id,
                    quantity: item2.quantity,
                    index: item2.index,
                    week: "4",
                    action: "fas fa-user"
                  });
                });
                this.items.data4 = week4;
              }

              // Week 5
              if (item.week === 5) {
                let week5 = [];
                item.pro_stock.forEach(item2 => {
                  week5.push({
                    isActive: true,
                    pro_stock_id: item2.pro_stock_id,
                    name: item2.product.name,
                    sku: item2.product_id,
                    quantity: item2.quantity,
                    index: item2.index,
                    week: "5",
                    action: "fas fa-user"
                  });
                });
                this.items.data5 = week5;
              }
            });
          }
        });
    },

    // For Multiselect purpose
    nameWithSKU({ name, sku }) {
      return `${name} — [${sku}]`;
    },

    // Get Outlet
    getProduct() {
      let param = "?type=" + this.$route.query.pro_cat;
      this.$store.dispatch("getProduct", param).then(res => {
        res.data.data.forEach((element, index) => {
          this.product_name.push({
            sku: element.product_id,
            name: element.name,
            index: index
          });
        });
      });
    },

    onClickDel(index, week) {
      this.curIndex = index;
      this.curWeek = week;
      this.$bvModal.show("delete-modal");
    },

    // Delete
    onClickDelConfirm() {
      let week = this.curWeek;
      let data = "";
      if (week === "1") {
        data = this.items.data1;
      } else if (week === "2") {
        data = this.items.data2;
      } else if (week === "3") {
        data = this.items.data3;
      } else if (week === "4") {
        data = this.items.data4;
      } else if (week === "5") {
        data = this.items.data5;
      }

      data.splice(this.curIndex, 1);
      this.curIndex = "";
      this.curWeek = "";
      this.$bvModal.hide("delete-modal");
      this.onClickReset();
    },

    // Edit
    onClickEdit(index, week) {
      this.curIndex = index;
      let data = "";
      this.disableWeek = true;

      if (week === "1") {
        data = this.items.data1;
      } else if (week === "2") {
        data = this.items.data2;
      } else if (week === "3") {
        data = this.items.data3;
      } else if (week === "4") {
        data = this.items.data4;
      } else if (week === "5") {
        data = this.items.data5;
      }

      let input = {
        sku: data[index].sku,
        name: data[index].name
      };
      this.input.product_name = input;
      this.input.qty = data[index].quantity;
      this.input.weeks = data[index].week;
    },

    // Add
    onClickAdd() {
      this.error.product_name = "";
      this.error.qty = "";

      this.checkForm();

      let data = "";

      if (this.input.weeks === "1") {
        data = this.items.data1;
      } else if (this.input.weeks === "2") {
        data = this.items.data2;
      } else if (this.input.weeks === "3") {
        data = this.items.data3;
      } else if (this.input.weeks === "4") {
        data = this.items.data4;
      } else if (this.input.weeks === "5") {
        data = this.items.data5;
      }
      if (this.curIndex !== "") {
        data[this.curIndex].name = this.input.product_name.name;
        data[this.curIndex].sku = this.input.product_name.sku;
        data[this.curIndex].quantity = this.input.qty;

        this.disableWeek = false;
      } else {
        data.push({
          isActive: true,
          name: this.input.product_name.name,
          sku: this.input.product_name.sku,
          index: String(this.input.product_name.index),
          quantity: this.input.qty,
          action: "fas fa-user",
          week: this.input.weeks
        });
      }

      this.tabIndex = parseInt(this.input.weeks) - 1;

      this.onClickReset();
    },

    checkForm: function(e) {
      if (this.input.qty && this.input.product_name) return true;
      this.error.product_name = "";
      this.error.qty = "";
      if (!this.input.product_name)
        this.error.product_name = "Product Name required.";
      if (!this.input.qty) this.error.qty = "Quantity required.";
      e.preventDefault();
    },

    // Reset
    onClickReset() {
      this.input.product_name = "";
      this.input.qty = "";
      this.curIndex = "";
    },

    onClickBack() {
      this.$router.go(-1);
    },

    onClickSubmit() {
      var forcast = [];
      if (this.items.data1.length >= 1) {
        let week1 = [];
        this.items.data1.forEach(item => {
          week1.push({
            product_id: item.sku,
            quantity: item.quantity
          });
        });

        forcast.push({
          week: 1,
          product: week1
        });
      }

      if (this.items.data2.length >= 1) {
        let week2 = [];
        this.items.data2.forEach(item => {
          week2.push({
            product_id: item.sku,
            quantity: item.quantity
          });
        });

        forcast.push({
          week: 2,
          product: week2
        });
      }

      if (this.items.data3.length >= 1) {
        let week3 = [];
        this.items.data3.forEach(item => {
          week3.push({
            product_id: item.sku,
            quantity: item.quantity
          });
        });

        forcast.push({
          week: 3,
          product: week3
        });
      }

      if (this.items.data4.length >= 1) {
        let week4 = [];
        this.items.data4.forEach(item => {
          week4.push({
            product_id: item.sku,
            quantity: item.quantity
          });
        });

        forcast.push({
          week: 4,
          product: week4
        });
      }

      if (this.items.data5.length >= 1) {
        let week5 = [];
        this.items.data5.forEach(item => {
          week5.push({
            product_id: item.sku,
            quantity: item.quantity
          });
        });

        forcast.push({
          week: 5,
          product: week5
        });
      }

      this.$store
        .dispatch("createMultiStock", {
          stock_id: this.$route.query.id,
          category: 5,
          category_amend: 3,
          forcast: forcast,
          type: this.$route.query.pro_cat
        })
        .then(res => {
          if (res.data.response.code === 1) {
            this.$router.push({ path: `stockout_changes_user` });
          }
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
